// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-member-badge {
    box-sizing: border-box;
    max-width: 400px;
    padding: 10px;
}
.group-member-badge__grid {
    display: grid;
    grid-template-columns: 120px auto;
} 
.group-member-badge .profile-image {
    width: 120px;
    height: 120px;
    margin-right: 5px;
    margin-bottom: 5px;
}
.group-member-badge__details {
    padding: 10px;
    align-items: center;
}
.group-member-badge__role {
    text-transform: capitalize;
    padding: 5px 0;
}
.group-member-badge__name {
    font-size: 18px;
    overflow-wrap: break-word;
}
.group-member-badge__about {
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./client/components/groups/members/GroupMembersList/GroupMemberBadge/GroupMemberBadge.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB","sourcesContent":[".group-member-badge {\n    box-sizing: border-box;\n    max-width: 400px;\n    padding: 10px;\n}\n.group-member-badge__grid {\n    display: grid;\n    grid-template-columns: 120px auto;\n} \n.group-member-badge .profile-image {\n    width: 120px;\n    height: 120px;\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n.group-member-badge__details {\n    padding: 10px;\n    align-items: center;\n}\n.group-member-badge__role {\n    text-transform: capitalize;\n    padding: 5px 0;\n}\n.group-member-badge__name {\n    font-size: 18px;\n    overflow-wrap: break-word;\n}\n.group-member-badge__about {\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
